// extracted by mini-css-extract-plugin
module.exports = {"Tabs":"Tabs_Tabs__QR4HO","ActiveTab":"Tabs_ActiveTab__2UJEG"};